import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const PresentationIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1H9C9 0.45 8.55 0 8 0C7.45 0 7 0.45 7 1H1C0.45 1 0 1.45 0 2C0 2.55 0.45 3 1 3V11C1 11.55 1.45 12 2 12H5.59L3.3 14.29C3.11 14.47 3 14.72 3 15C3 15.55 3.45 16 4 16C4.28 16 4.53 15.89 4.71 15.71L7 13.41V15C7 15.55 7.45 16 8 16C8.55 16 9 15.55 9 15V13.41L11.29 15.7C11.47 15.89 11.72 16 12 16C12.55 16 13 15.55 13 15C13 14.72 12.89 14.47 12.71 14.29L10.41 12H14C14.55 12 15 11.55 15 11V3C15.55 3 16 2.55 16 2C16 1.45 15.55 1 15 1ZM13 10H3V3H13V10Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default PresentationIcon;
